<template>
  <v-card id="diseases" class="mb-2">
    <v-card-title>
      <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('diseases')" color="white">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
      <h2>Диагноз</h2>

      <div class="ml-auto">
        <modal depressed icon="add" title="Добавить заболевание" name="Диагноз" component="add-diseases"></modal>
      </div>
    </v-card-title>

    <v-data-table
      v-if="isShow"
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      :server-items-length="meta.total"
      @click:row="editItem"
    >
      <template v-slot:top>
        <v-container fluid>
          <v-row no-gutters justify="space-between">
            <v-col cols="12" sm="3">
              <date-range-picker v-model="filter.date" @input="load" />
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3">
              <v-text-field
                class="pa-0 ma-0"
                label="Поиск"
                append-icon="mdi-magnify"
                single-line
                v-model="search"
                @input="apiSearch"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:item.title="{ item }">
        <div v-if="item.icd10 && item.icd10.translations">
          {{ item.icd10.translations.ru.name }}
        </div>
        <div v-else>{{ item.title }}</div>
      </template>

      <template v-slot:item.code="{ item }">
        <div v-if="item.icd10">{{ item.icd10.code }}</div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon v-if="allowEdit" class="mr-2">mdi-pencil</v-icon>
        <v-icon @click.stop="deleteItem(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import Modal from "@/components/Modal";

import throttle from "lodash/throttle";
import { mapState, mapMutations } from "vuex";
import { QueryHelper } from "@/services/query-helper";
import DateRangePicker from "@/components/forms/DateRangePicker";
import AddDiseases from "@/components/modals/AddDiseases";
import { CustomerService } from "@/services/api/customer.service";
import { FLAGS } from "@/configs";

export default {
  name: "Diseases",
  components: { DateRangePicker, Modal },
  data: () => ({
    loading: true,
    options: {},
    search: "",
    filter: {
      date: [],
    },
    headers: [
      { text: "Заболевания", value: "title", align: "start", sortable: true },
      { text: "Тип диагноза", value: "type", align: "start", sortable: true },
      { text: "Код болезни", value: "code", align: "start", sortable: false },
      { text: "Дата начала", value: "date_start", align: "start", sortable: true },
      { text: "Дата окончания", value: "date_end", align: "start", sortable: false },
      { text: "Примечания", value: "details", align: "start", sortable: false },
      { text: "Действия", value: "actions", sortable: false },
    ],
  }),

  computed: {
    isShow() {
      return !this.closedBlocks.includes("diseases");
    },
    customerId() {
      return this.$store.state.customer.id;
    },
    allowEdit() {
      const hgFlag = this.$featureFlags.feature(FLAGS.ALLOW_EDIT_DIAGNOSIS);
      return hgFlag._value === "1";
    },
    ...mapState("diseases", ["items", "meta"]),
    ...mapState("ikp", ["closedBlocks"]),
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },


  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),

    async load() {
      this.loading = true;

      try {
        const params = {
          search: this.search,
          ...QueryHelper.tableSorting(this.options),
          ...QueryHelper.filter(this.filter),
          ...QueryHelper.pagination(this.options, this.meta.total),
        };

        const response = await this.$http.get(`v1/customers/${this.customerId}/diseases`, { params }).then(r => r.data);
        this.$store.commit("diseases/SET_META_TOTAL", response.meta.total);
        this.$store.commit("diseases/SET_ITEMS", response.data);
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.$store.commit("diseases/SET_ITEMS", []);
        this.$store.commit("diseases/SET_META_TOTAL", 0);
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    /**
     * @param {DiseasesItem} item
     * @return {Promise<void>}
     */
    async editItem(item) {
      if (!this.allowEdit) {
        return;
      }
      const response = await CustomerService.getDisease(this.customerId, item.id);
      this.$dialog.show(AddDiseases, { model: response, width: 600, editOnlyComment: true, persistent: true });
    },

    async deleteItem(item) {
      const title = item.title ? `"${item.title}"` : "";
      const result = await this.$dialog.confirm({
        title: "Удаление заболевания",
        text: `Вы подтверждаете удаление заболевания ${title}`,
      });

      if (result) {
        this.loading = true;
        await this.$store.dispatch("diseases/removeItem", item);

        if (this.items.length === 0) {
          await this.load();
        }

        this.loading = false;
      }
    },
  },
};
</script>
